<ngx-datatable
  (activate)="goToItem($event)"
  [footerHeight]="50"
  [headerHeight]="50"
  [limit]="10"
  [reorderable]="true"
  [rowHeight]="100"
  [rows]="tableRows"
  [scrollbarH]="true"
  [scrollbarV]="false"
  columnMode="force"
  ngClass="bootstrap">
  @if (columnVisible.image) {
    <ngx-datatable-column name="Image" prop="image">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-thumbnail slot="start">
          @if (!row.image) {
            <ion-icon name="camera-outline"></ion-icon>
          }
          @if (row.image) {
            <cdn-img [src]="row.image" alt="item-thumbnail" class="ion-no-padding" size="sm" />
          }
        </ion-thumbnail>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.numberId) {
    <ngx-datatable-column name="ID" prop="numberId">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text>{{ row.numberId }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.category) {
    <ngx-datatable-column name="Category" prop="category">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text>{{ itemCategoryToString(row.category) }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.name) {
    <ngx-datatable-column name="Name" prop="name">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text>{{ itemNameToString(row) }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.location) {
    <ngx-datatable-column name="Location" prop="location">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text>{{ row.location }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.status) {
    <ngx-datatable-column name="Status" prop="status">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <rc-item-status-badge [itemStatus]="row.status"></rc-item-status-badge>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnVisible.reclaimedAt) {
    <ngx-datatable-column name="Reclaimed on" prop="reclaimedAt">
      <ng-template let-row="row" ngx-datatable-cell-template>
        @if (tryParseDate(row.reclaimedAt); as reclaimedOn) {
          <ion-text>{{ reclaimedOn | date: "mediumDate" }}</ion-text>
        } @else {
          <ion-text class="item-table__no-date">Not recorded</ion-text>
        }
      </ng-template>
    </ngx-datatable-column>
  }
</ngx-datatable>
